import { render, staticRenderFns } from "./SaveConfigScheme.vue?vue&type=template&id=0b39c700&scoped=true"
import script from "./SaveConfigScheme.vue?vue&type=script&lang=js"
export * from "./SaveConfigScheme.vue?vue&type=script&lang=js"
import style0 from "./SaveConfigScheme.vue?vue&type=style&index=0&id=0b39c700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39c700",
  null
  
)

export default component.exports